/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import {
    GraphQLObjectType as ObjectType,
    GraphQLString as StringType,
    GraphQLID as ID,
    GraphQLNonNull as NonNull,
} from 'graphql';


const SloganType = new ObjectType({
    name: 'SloganItem',
    description: 'Cet objet represente un slogan',
    fields: () => ({
        id: {
            type: new NonNull(ID),
            description: 'Le id du slogan',
            resolve: (root) => root.id
        },
        slug: {
            type: StringType,
            description: 'Le slug du slogan',
            resolve: (root) => root.slug
        },
        title: {
            type: StringType,
            description: 'Le titre du slogan',
            resolve: (root) => root.title.rendered
        },
        content: {
            type: StringType,
            description: 'Le content du slogan',
            resolve: (root) => root.content.rendered
        },
        thumbnail: {
            type: StringType,
            description: 'Le thumbnail du slogan',
            resolve: (root) => root.acf.icone_slogan_accueil
        },
        lien: {
            type: StringType,
            description: 'Le lien du slogan',
            resolve: (root) => root.acf.lien_slogan
        },
    }),
});

export default SloganType;



// WEBPACK FOOTER //
// ./data/types/SloganType.js